<template>
  <div class="error-container">
    <div class="error-wrap">
      <strong class="notice-title">{{
        $t('페이지를 찾을 수 없습니다.')
      }}</strong>
      <p class="notice-content">
        <template v-if="$i18n.locale == 'ko'">
          주소가 잘못 입력되었거나 원하시는 페이지를 찾을 수 없습니다. <br />
          입력하신 페이지 주소가 정확한지 다시 한 번 확인해 보시기 바랍니다.
        </template>
        <template v-else-if="$i18n.locale == 'en'">
          The address is incorrectly entered or the page you are looking for
          cannot be found. <br />
          Please check again to make sure the page address you entered is
          correct.
        </template>
      </p>
      <div class="button-container align-hor">
        <button
          type="button"
          class="btn type-box btn-outlined medium"
          @click="$router.go(-1)"
        >
          <span class="text">{{ $t('이전 페이지') }}</span>
        </button>

        <button
          @click="$router.push(`/console/${$store.state.tenant}`)"
          type="button"
          class="btn type-box btn-primary medium"
        >
          <span class="text">{{ $t('메인 페이지') }}</span>
          <!-- main page  -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(`not`);
  },
};
</script>

<style scoped>
button span,
button div,
button p {
  font-family: 'Pretendard';
}

.wrapper {
  height: 100%;
}

p.strong {
  font-weight: 500;
  font-size: 14px;
  color: #8e8e8e;
  line-height: 20px;
  padding: 6px 0;
  margin: 0 30px 0 0;
  display: block;
  text-align: center;
}

/* ----------------------- Error ------------------- */
html,
body {
  height: 100%;
}

.error-container {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.error-wrap {
  text-align: center;
  padding-top: 80px;
  background-image: url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 20.6079C7 18.6153 8.63668 17 10.6556 17H54.5232C56.5422 17 58.1789 18.6153 58.1789 20.6079V54.2816C58.1789 56.2742 56.5422 57.8895 54.5232 57.8895H10.6556C8.63668 57.8895 7 56.2742 7 54.2816V20.6079ZM10.6556 19.4053C9.98265 19.4053 9.43709 19.9437 9.43709 20.6079V54.2816C9.43709 54.9458 9.98265 55.4842 10.6556 55.4842H54.5232C55.1962 55.4842 55.7418 54.9458 55.7418 54.2816V20.6079C55.7418 19.9437 55.1962 19.4053 54.5232 19.4053H10.6556Z' fill='%23171717'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.9668 41.3529C17.9668 40.8548 18.376 40.4509 18.8807 40.4509H43.8609C44.3656 40.4509 44.7748 40.8548 44.7748 41.3529C44.7748 41.851 44.3656 42.2549 43.8609 42.2549H18.8807C18.376 42.2549 17.9668 41.851 17.9668 41.3529Z' fill='black' fill-opacity='0.1'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.9668 47.3663C17.9668 46.8682 18.376 46.4644 18.8807 46.4644H43.8609C44.3656 46.4644 44.7748 46.8682 44.7748 47.3663C44.7748 47.8645 44.3656 48.2683 43.8609 48.2683H18.8807C18.376 48.2683 17.9668 47.8645 17.9668 47.3663Z' fill='black' fill-opacity='0.1'/%3E%3Cpath d='M48.431 23.6138C48.431 24.6101 47.6127 25.4177 46.6032 25.4177C45.5937 25.4177 44.7754 24.6101 44.7754 23.6138C44.7754 22.6175 45.5937 21.8098 46.6032 21.8098C47.6127 21.8098 48.431 22.6175 48.431 23.6138Z' fill='%23171717'/%3E%3Cpath d='M53.3031 23.6138C53.3031 24.6101 52.4848 25.4177 51.4753 25.4177C50.4658 25.4177 49.6475 24.6101 49.6475 23.6138C49.6475 22.6175 50.4658 21.8098 51.4753 21.8098C52.4848 21.8098 53.3031 22.6175 53.3031 23.6138Z' fill='%23004181'/%3E%3Cpath d='M55.9345 39.0223C56.414 38.2846 57.5063 38.2846 57.9858 39.0223L71.5857 59.9456C72.106 60.7461 71.5236 61.7976 70.5601 61.7976H43.3602C42.3966 61.7976 41.8143 60.7461 42.3345 59.9456L55.9345 39.0223Z' fill='%23004181'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M54.9087 38.3727C55.8676 36.8973 58.0523 36.8973 59.0112 38.3727L72.6112 59.296C73.6517 60.8969 72.487 63 70.5599 63H43.36C41.4329 63 40.2682 60.8969 41.3087 59.296L54.9087 38.3727ZM56.9599 39.6714L43.36 60.5947L70.5599 60.5947L56.9599 39.6714Z' fill='%23171717'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M56.9602 47.0652C56.4218 47.0652 55.9854 47.4959 55.9854 48.0273V52.8378C55.9854 53.3692 56.4218 53.7999 56.9602 53.7999C57.4986 53.7999 57.935 53.3692 57.935 52.8378V48.0273C57.935 47.4959 57.4986 47.0652 56.9602 47.0652ZM56.9602 56.6862C57.4986 56.6862 57.935 56.2555 57.935 55.7241C57.935 55.1928 57.4986 54.762 56.9602 54.762C56.4218 54.762 55.9854 55.1928 55.9854 55.7241C55.9854 56.2555 56.4218 56.6862 56.9602 56.6862Z' fill='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: 50% 0;
}
.error-wrap .notice-title {
  display: block;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  color: #171717;
}
.error-wrap .notice-content {
  margin-bottom: 56px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #8e8e8e;
}
.error-wrap .button-container {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 96px;
}

/* ----------------------------------- 버튼 ----------------------------------- */
.button-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  /* -------------------------------------------------------------------------- */
  /*                                 button Box                                 */
  /* -------------------------------------------------------------------------- */
}
.button-container.align-hor {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}
.button-container.align-hor .btn.large,
.button-container.align-hor .btn.medium {
  margin-left: 6px;
  margin-right: 6px;
}
.button-container.align-hor .btn.small {
  margin-left: 4px;
  margin-right: 4px;
}
.button-container.align-hor .btn:first-child {
  margin-left: 0;
}
.button-container.align-hor .btn:last-child {
  margin-right: 0;
}
.button-container.align-ver {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.button-container.align-ver .btn.large,
.button-container.align-ver .btn.medium {
  margin-top: 6px;
  margin-bottom: 6px;
}
.button-container.align-ver .btn.small {
  margin-top: 4px;
  margin-bottom: 4px;
}
.button-container.align-ver .btn:first-child {
  margin-top: 0;
}
.button-container.align-ver .btn:last-child {
  margin-bottom: 0;
}
.button-container .type-box.btn {
  padding: 12px 16px 12px 16px;
  border-radius: 2px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
}
.button-container .type-box.btn:disabled {
  cursor: default;
}
.button-container .type-box.btn:disabled .icon {
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.29158 16.3334C9.29158 16.7246 9.60872 17.0417 9.99992 17.0417C10.3911 17.0417 10.7083 16.7246 10.7083 16.3334V11.2084H15.8333C16.2245 11.2084 16.5416 10.8912 16.5416 10.5C16.5416 10.1088 16.2245 9.79171 15.8333 9.79171H10.7083V4.66671C10.7083 4.27551 10.3911 3.95837 9.99992 3.95837C9.60872 3.95837 9.29158 4.27551 9.29158 4.66671V9.79171H4.16659C3.77538 9.79171 3.45825 10.1088 3.45825 10.5C3.45825 10.8912 3.77538 11.2084 4.16659 11.2084H9.29158V16.3334Z' fill='black' fill-opacity='0.15'/%3E%3C/svg%3E%0A");
}
.button-container .type-box.btn .text {
  display: inline-block;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.button-container .type-box.btn .icon + .text {
  margin-left: 8px;
}
.button-container .type-box.btn .text + .icon {
  margin-left: 8px;
}
.button-container .type-box.btn.btn-primary {
  background-color: #004181;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
  border: 0;
}
.button-container .type-box.btn.btn-primary .text {
  color: #ffffff;
}
.button-container .type-box.btn.btn-primary:hover {
  background: -webkit-gradient(
      linear,
      left bottom,
      left top,
      from(rgba(255, 255, 255, 0.1)),
      to(rgba(255, 255, 255, 0.1))
    ),
    #004181;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.1)
    ),
    #004181;
}
.button-container .type-box.btn.btn-primary:active {
  background-color: #0a8294;
}
.button-container .type-box.btn.btn-primary:disabled {
  background: #f7f7f7;
}
.button-container .type-box.btn.btn-primary:disabled .text {
  color: rgba(0, 0, 0, 0.15);
}
.button-container .type-box.btn.btn-secondary {
  background: #f0f4f8;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.button-container .type-box.btn.btn-secondary .text {
  color: #004181;
}
.button-container .type-box.btn.btn-secondary:hover {
  background: -webkit-gradient(
      linear,
      left bottom,
      left top,
      from(rgba(0, 0, 0, 0.05)),
      to(rgba(0, 0, 0, 0.05))
    ),
    #f0f4f8;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
    #f0f4f8;
}
.button-container .type-box.btn.btn-secondary:active {
  border-color: #0a8294;
  color: #0a8294;
}
.button-container .type-box.btn.btn-secondary:disabled {
  border-color: #b8b8b8;
}
.button-container .type-box.btn.btn-secondary:disabled .text {
  color: rgba(0, 0, 0, 0.15);
}
.button-container .type-box.btn-outlined {
  border: 1px solid #004181;
  background: #fff;
  padding: 12px 15px 12px 15px;
}
.button-container .type-box.btn-outlined .text {
  color: #004181;
}
.button-container .type-box.btn-outlined:hover {
  background: -webkit-gradient(
      linear,
      left bottom,
      left top,
      from(rgba(0, 0, 0, 0.05)),
      to(rgba(0, 0, 0, 0.05))
    ),
    #ffffff;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
    #ffffff;
}
.button-container .type-box.btn-outlined:disabled {
  background: #f7f7f7;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.button-container .type-box.btn-outlined:disabled .text {
  color: rgba(0, 0, 0, 0.15);
}
.button-container .type-box.large {
  height: 48px;
}
.button-container .type-box.medium {
  height: 40px;
}
.button-container .type-box.medium .text {
  font-size: 14px;
  line-height: 20px;
}
.button-container .type-box.medium .icon + .text {
  margin-left: 4px;
}
.button-container .type-box.medium .text + .icon {
  margin-left: 4px;
}
.button-container .type-box.small {
  height: 32px;
}
.button-container .type-box.small .text {
  font-size: 14px;
  line-height: 20px;
}
.button-container .type-box.small .icon + .text {
  margin-left: 4px;
}
.button-container .type-box.small .text + .icon {
  margin-left: 4px;
}
.button-container .type-box.full-size {
  width: 100%;
}
</style>
